<div class="app-shell">
  <div class="app-shell-header">
    <div class="app-shell-navbar-left"> </div>
    @for (link of links; track link) {
      @if (!link.data?.isHidden) {
        <a class="app-shell-navbar-link"
          [routerLink]="generateLinkPath(link.path)"
          [ngClass]="{'active': isActiveLink(link.originalPath || link.path)}"
          title="{{ $safeNavigationMigration(link.data?.titleKey) | translate: 'navigation' }}"> <span>{{ $safeNavigationMigration(link.data?.titleKey) | translate: 'navigation' }}</span>
        </a>
      }
    }
    @if (!appSettings.isProduction) {
      @if (!isDarkTheme) {
        <div
          class="app-shell-navbar-link theme ms-auto me-4"
        (click)="applyDarkTheme()">Dark</div>
      }
      @if (isDarkTheme) {
        <div
          class="app-shell-navbar-link theme ms-auto me-4"
        (click)="applyLightTheme()">Light</div>
      }
    }
    <div class="app-sign-out me-4"
      [class.ms-auto]="appSettings.isProduction"
      title="{{username}} &ndash; {{ 'SignOut' | translate:'assets' }}"
      (click)="signOut()">
      @if (!userThumbnail) {
        <svg-icon
          src="{{iconSet.arrowRight}}"
        class="eshava-assets-svg"></svg-icon>
      }
      @if (userThumbnail) {
        <img class="user-thumbnail"
          [src]="userThumbnail">
      }
    </div>
  </div>
  <div class="app-shell-content">
    <div class="app-shell-sidebar">
      <div class="list-group list-group-flush">
        @for (item of menuItems; track item) {
          <a class="list-group-item list-group-item-action"
            [routerLink]="['/',item.path]"
            routerLinkActive="active"
            title="{{ item.titleKey | translate:'navigation' }}">
            <svg-icon src="{{item.icon}}"
            class="eshava-assets-svg"></svg-icon>
          </a>
        }
      </div>
    </div>
    <div class="app-shell-content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<lib-context-menu></lib-context-menu>